export const SHOPIFY_PAGE_ID_PREFIX = 'gid://shopify/';
export const SHOPIFY_PAGE_ID_KEY = 'shopify_page_id';
export const LOCATION_PATH_KEY = 'location_path';
export const SHOPIFY_PAGE_TYPE_KEY = 'shopify_page_type';
